module.exports = __webpack_public_path__ + "static/media/img_medal-rules@2x.0476adc0.png";